<script lang="ts">
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.999 19.988">
	<g>
		<path
			class:active
			class:hover
			d="M53.787 442.549v8.281a.636.636 0 0 1-.636.635h-7.843a.635.635 0 0 1-.635-.635v-8.281a.635.635 0 0 1 .635-.636h7.843a.636.636 0 0 1 .636.636zm-6.31 3.256h3.5a.635.635 0 0 0 .636-.635.635.635 0 0 0-.636-.636h-3.5a.635.635 0 0 0-.635.636.635.635 0 0 0 .635.63z"
			transform="translate(-44.673 -431.477)" />
		<path
			class:active
			class:hover
			d="M80.783 442.551v8.28a.635.635 0 0 1-.635.635h-7.842a.635.635 0 0 1-.635-.635v-8.28a.635.635 0 0 1 .635-.635h7.841a.635.635 0 0 1 .636.635zm-2.806 1.979h-3.5a.636.636 0 0 0-.636.636.636.636 0 0 0 .636.635h3.5a.635.635 0 0 0 .635-.635.635.635 0 0 0-.635-.636z"
			transform="translate(-60.784 -431.478)" />
		<path
			class:active
			class:hover
			d="M67.715 416.669v7.846a.636.636 0 0 1-.636.635H58.8a.636.636 0 0 1-.635-.635v-7.846a.635.635 0 0 1 .635-.636h8.284a.635.635 0 0 1 .631.636zm-7.372 2.61v.007a.635.635 0 0 0 .636.635H64.9a.636.636 0 0 0 .635-.635v-.007a.636.636 0 0 0-.635-.635h-3.92a.635.635 0 0 0-.637.634z"
			transform="translate(-52.722 -416.033)" />
	</g>
</svg>

<style lang="scss">
	path {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
